import React, { useState } from "react";
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Registrar_calaverita = () => {
    // variables de formulario
    const [idUsuario, setIdUsuario] = useState("");
    const [nombreRegistroCalaverita, setNombreRegistroCalaverita] = useState("");
    const [apellidoRegistroCalaverita, setApellidoRegistroCalaverita] = useState("");
    const [idCuentaHabienteCalaverita, setIdCuentaHabienteCalaverita] = useState("");
    const [emailRegistroCalaverita, setEmailRegistroCalaverita] = useState("");
    const [estadoRegistroCalaverita, setEstadoRegistroCalaverita] = useState("");
    const [celularRegistroCalaverita, setCelularRegistroCalaverita] = useState("");
    const [calaveritaTextoRegistro, setCalaveritaTextoRegistro] = useState("");
    const [idCuentaHabienteValidado, setIdCuentaHabienteValidado] = useState(false);
    const [maxCaracteres, setMaxCaracteres] = useState(1500);
    const [mostrarFelicitacion, setMostrarFelicitacion] = useState(false);
    const [loader, setLoader] = useState(false);
    function checkDataInput(e){
        if(e.target.id === "nombreRegistroCalaverita"){ setNombreRegistroCalaverita(e.target.value);}
        if(e.target.id === "apellidoRegistroCalaverita"){ setApellidoRegistroCalaverita(e.target.value)}
        if(e.target.id === "idCuentaHabienteCalaverita"){ setIdCuentaHabienteCalaverita(e.target.value)}
        if(e.target.id === "emailRegistroCalaverita"){ setEmailRegistroCalaverita(e.target.value)}
        if(e.target.id === "estadoRegistroCalaverita"){ setEstadoRegistroCalaverita(e.target.value)}
        if(e.target.id === "celularRegistroCalaverita"){ setCelularRegistroCalaverita(e.target.value)}
        if(e.target.id === "calaveritaTextoRegistro"){ 
            setCalaveritaTextoRegistro(e.target.value);
            setMaxCaracteres(1500 - e.target.value.length);
        }
    }
    function validarIdCuentaHabiente(){
        if(idCuentaHabienteCalaverita === ""){
            return false;
        }else{
            axios({
                url: process.env.REACT_APP_API+'/api/users/account_num/' + idCuentaHabienteCalaverita,
                method: 'GET',
                headers: { 'Content-Type': 'application/json'},
            })
            .then((response) => {
                if (response.data.status === true) {
                    console.log("Resp. validacion id: ", response);
                    setIdCuentaHabienteValidado(true);
                    llenarCamposFormulario(response.data.data);
                    toast.success('Id de cuentahabiente correcto', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false,
                    }); 
                } else {
                    setIdCuentaHabienteValidado(false);
                    toast.error('No existe el número de cuentahabiente', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    }); 
                }
            })
            .catch((e) => {
                console.error("error" + e);
            })
        }
    }
    function llenarCamposFormulario(data){
        setIdUsuario(data.id);
        setCelularRegistroCalaverita(data.cellphone);
        setApellidoRegistroCalaverita(data.lastname);
        setNombreRegistroCalaverita(data.name);
        setEmailRegistroCalaverita(data.email);
    }
    function limpiarFormulario(){
        setIdUsuario("");
        setNombreRegistroCalaverita("");
        setApellidoRegistroCalaverita("");
        setIdCuentaHabienteCalaverita("");
        setEmailRegistroCalaverita("");
        setEstadoRegistroCalaverita("");
        setCelularRegistroCalaverita("");
        setCalaveritaTextoRegistro("");
        setIdCuentaHabienteValidado(false);
        setMaxCaracteres(1500);
    }
    function registroCalaverita(e){
        e.preventDefault();
        if(nombreRegistroCalaverita.length !== " " || 
            apellidoRegistroCalaverita.length !== " " ||
            idCuentaHabienteCalaverita.length !== " " ||
            emailRegistroCalaverita.length !== " " ||
            estadoRegistroCalaverita.length !== " " ||
            celularRegistroCalaverita.length !== " " ||
            calaveritaTextoRegistro.length !== " " || 
            idCuentaHabienteValidado === true){
            setLoader(true);
            let data = {
                "user_id": idUsuario ,
                "microsite_id": 109,
                "nombre": nombreRegistroCalaverita,
                "apellido": apellidoRegistroCalaverita,
                "id": idCuentaHabienteCalaverita,
                "email": emailRegistroCalaverita,
                "estado": estadoRegistroCalaverita,
                "celular": celularRegistroCalaverita,
                "calaverita": calaveritaTextoRegistro,
                "ofrenda": ""
            }
            axios({
                url: process.env.REACT_APP_API+'/api/calaveritas-y-ofrendas',
                method: 'POST',
                headers: { 'Content-Type': 'application/json'},
                data,
            })
            .then((response) => {
                if (response.data.status === true) {
                    setLoader(false);
                    console.info("Registrado correctamente", response);
                    toast.success('Registrado correctamente', {
                        position: "top-right",
                        autoClose: false,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false,
                    }); 
                    setMostrarFelicitacion(true);
                    limpiarFormulario();
                } else {
                    setLoader(false);
                    if(idCuentaHabienteValidado === false){
                        toast.error('Valida tu Id de cuentahabiente', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        }); 
                    }else{
                        console.error("No se pudo registrar", response);
                        toast.error('No se pudo registrar', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        }); 
                    }
                }
            })
            .catch((e) => {
                console.error("error" + e);
            })

        }else{
            return false;
        }
    }
    return (
        <div className="container pb-5">
            <ToastContainer/>
            <div id="registra-caleverita" className="section">
                <div className="row">
                    <div className="col-12 text-center">
                        <img src={process.env.PUBLIC_URL+'/img/LOGO DESKTOP.png'} className="img-calavera oculto" alt="calaveritas 2022" />
                        <p className="tform">Ponte creativo, sube tu calaverita dedicada a Martha Debayle o cualquier miembro de la producción y gana premios espectaculares.</p>
                    </div>
                </div>
            </div>
            <div className="container forms">
                { mostrarFelicitacion === false ? 
                <form className="col-md-12 needs-validation" id="form-calaverita" onSubmit={registroCalaverita}>
                      <div className="input-group">
                        <button className="btn btn-outline-secondary btnValidarAutocompletacion" type="button" id="button-addon1"  onClick={validarIdCuentaHabiente} readOnly>MD -</button>
                        <input className="form-control py-2" type="text" value={idCuentaHabienteCalaverita} name="idCuentaHabienteCalaverita" id="idCuentaHabienteCalaverita" placeholder="ID Cuentahabiente" aria-label="Recipient's username" aria-describedby="button-addon1" onChange={checkDataInput} required/>
                        <button className="btn btn-outline-secondary btnValidar" type="button" id="button-addon2"  onClick={validarIdCuentaHabiente}>Validar Id</button>
                    </div>
                    <div className="form-group id-cuenta mb-3">
                        <a href="https://mmkg.net/registro" className="IdCuenta" rel="noreferrer" target="_blank">
                            Saca tu ID de cuentahabiente
                        </a>
                    </div>
                    <div className="form-row">
                        <div className="form-group col-md-12 mb-3">
                            <input className="form-control py-2" value={nombreRegistroCalaverita} type="text" name="nombreRegistroCalaverita" id="nombreRegistroCalaverita" onChange={checkDataInput} placeholder="Nombre" required/>
                        </div>
                        <div className="form-group col-md-12 mb-3">
                            <input className="form-control py-2" value={apellidoRegistroCalaverita} type="text" name="apellidoRegistroCalaverita" id="apellidoRegistroCalaverita" onChange={checkDataInput} placeholder="Apellido" required/>
                        </div>
                    </div>
                  
                    
                    <div className="form-group mb-3">
                        <input className="form-control py-2" type="email" value={emailRegistroCalaverita} name="emailRegistroCalaverita" id="emailRegistroCalaverita" onChange={checkDataInput} placeholder="Correo electrónico" required/>
                    </div>
                    <div className="row">
                        <div className="form-group col-md-6 mb-3">
                            <select className="form-control py-2" name="estadoRegistroCalaverita" value={estadoRegistroCalaverita} id="estadoRegistroCalaverita" onChange={checkDataInput} required>
                                <option value="" disabled>Estado</option>
                                <option value="1">Aguascalientes</option>
                                <option value="2">Baja California</option>
                                <option value="3">Baja California Sur</option>
                                <option value="4">Campeche</option>
                                <option value="5">Coahuila</option>
                                <option value="6">Colima</option>
                                <option value="7">Chiapas</option>
                                <option value="8">Chihuahua</option>
                                <option value="9">Ciudad de México</option>
                                <option value="10">Durango</option>
                                <option value="11">Guanajuato</option>
                                <option value="12">Guerrero</option>
                                <option value="13">Hidalgo</option>
                                <option value="14">Jalisco</option>
                                <option value="15">México</option>
                                <option value="16">Michoacán</option>
                                <option value="17">Morelos</option>
                                <option value="18">Nayarit</option>
                                <option value="19">Nuevo León</option>
                                <option value="20">Oaxaca</option>
                                <option value="21">Puebla</option>
                                <option value="22">Querétaro</option>
                                <option value="23">Quintana Roo</option>
                                <option value="24">San Luis Potosí</option>
                                <option value="25">Sinaloa</option>
                                <option value="26">Sonora</option>
                                <option value="27">Tabasco</option>
                                <option value="28">Tamaulipas</option>
                                <option value="29">Tlaxcala</option>
                                <option value="30">Veracruz</option>
                                <option value="31">Yucatán</option>
                                <option value="32">Zacatecas</option>
                            </select>
                        </div>
                        <div className="form-group col-md-6">
                            <input className="form-control py-2" value={celularRegistroCalaverita} type="text" name="celularRegistroCalaverita" id="celularRegistroCalaverita" placeholder="Celular" pattern="^\d{10}$" onChange={checkDataInput} required />
                        </div>

                        <div className="form-group col-md-12">
                            <textarea className="form-control py-2" name="calaveritaTextoRegistro" value={calaveritaTextoRegistro} id="calaveritaTextoRegistro" rows="5" cols="30" maxLength="1500" placeholder="Calaverita (1,500 caracteres)" onChange={checkDataInput} required></textarea>
                        </div>
                    </div>
                    <div className="col-md-12" align="right" id="sobran">
                        Caracteres restantes {maxCaracteres}
					</div>
                    <div className="row">
                        <div className="col-md-12 text-center mt-3">
                            <button id="btn-calavera" type="submit" className="btn btn-danger">
                                { loader === true ?
                                <span class="spinner-border spinner-border-sm me-3"></span>
                                :
                                <span></span>
                                }
                                Registra tu calaverita
                            </button> 
                        </div>
                    </div>
                </form>
                :
                <div class="container containerSuccess mt-5">
                    <h1 class="text-center text-light">¡ Felicidades tu registro se ha completo!</h1>
                    <div class="containerGifSuccess">
                    </div>
                </div>
                }
            </div>
        </div>
    );
};
export default Registrar_calaverita;